<template>
  <div
    v-if="loaded"
    class="page laboratory-module"
  >
    <div class="page__sidebar">
      <laboratory-side-bar />
    </div>
    <div class="page__main">
      <router-view
        ref="mainContent"
        class="page__main-content"
      />
    </div>
  </div>
</template>

<script>
import LaboratorySideBar from './sideBar/LaboratorySideBar'
import { assayState } from '@/api/resources/entityState/assay-state'
import laboratorySampleServices from '@/modules/laboratoryModule/services/laboratorySampleServices'
import { PromiseUtils } from '@/shared/util/promise-utils'
import { StoreUtils } from '@/shared/util/store-utils'

export default {
    name: 'LaboratoryIndex',
    components: {
        LaboratorySideBar
    },
    data() {
        return {
            loaded: false
        }
    },
    beforeDestroy() {
        StoreUtils.cleanSearchState()
    },
    async mounted() {
        const response =
            await PromiseUtils.toCallSecure(
                Promise.all([
                    assayState.loadStates(),
                    laboratorySampleServices.getSampleStates()
                ]))
        if (response !== null) {
            this.loaded = true
        }
    }
}
</script>
